import React from 'react';
import { styled } from 'styled-components';
import { Quote, Center } from '../components/UI';
import { Carousel } from '../components/Carousel';
import { Card } from '../components/Card';

const ReviewsContainer = styled.div`
  display: block;
  max-width: 70%;
`;

export const Reviews = ({ content }) => {
  return (
    <Center>
      <ReviewsContainer>
        <Carousel>
          {content.map(({ body, author }) => (
            <Card>
              <Quote>{body}</Quote>
              {author && <span>{author}</span>}
            </Card>
          ))}
        </Carousel>
      </ReviewsContainer>
    </Center>
  );
};
